let materialConfig = function($mdThemingProvider) {
    //https://angular-md-color.com/#/
    var customPrimary = {
        '50': '#a2d7a4',
        '100': '#90cf92',
        '200': '#7ec781',
        '300': '#6cc070',
        '400': '#5ab85e',
        '500': '#4bae4f',
        '600': '#439c47',
        '700': '#3c8a3f',
        '800': '#347937',
        '900': '#2c672f',
        'A100': '#b4deb5',
        'A200': '#c5e6c7',
        'A400': '#d7eed8',
        'A700': '#255527',
        'contrastDefaultColor': 'light'
    };
    $mdThemingProvider
        .definePalette('customPrimary',
            customPrimary);

    var customAccent = {
        '50': '#000a08',
        '100': '#00231d',
        '200': '#003d31',
        '300': '#005646',
        '400': '#00705a',
        '500': '#00896f',
        '600': '#00bc97',
        '700': '#00d6ac',
        '800': '#00efc0',
        '900': '#0affcf',
        'A100': '#00bc97',
        'A200': '#00a383',
        'A400': '#00896f',
        'A700': '#23ffd4'
    };
    $mdThemingProvider
        .definePalette('customAccent',
            customAccent);

    var customWarn = {
        '50': '#ff5555',
        '100': '#ff3c3c',
        '200': '#ff2222',
        '300': '#ff0909',
        '400': '#ee0000',
        '500': '#d50000',
        '600': '#bb0000',
        '700': '#a20000',
        '800': '#880000',
        '900': '#6f0000',
        'A100': '#ff6f6f',
        'A200': '#ff8888',
        'A400': '#ffa2a2',
        'A700': '#d50000'
    };
    $mdThemingProvider
        .definePalette('customWarn',
            customWarn);

    var customBackground = {
        '50': '#ffffff',
        '100': '#ffffff',
        '200': '#ffffff',
        '300': '#ffffff',
        '400': '#ffffff',
        '500': '#f8f8f8',
        '600': '#ebebeb',
        '700': '#dedede',
        '800': '#d2d2d2',
        '900': '#c5c5c5',
        'A100': '#ffffff',
        'A200': '#ffffff',
        'A400': '#ffffff',
        'A700': '#b8b8b8'
    };
    $mdThemingProvider
        .definePalette('customBackground',
            customBackground);

    $mdThemingProvider.theme('default')
        .primaryPalette('customPrimary')
        .accentPalette('customAccent')
        .warnPalette('customWarn')
        .backgroundPalette('customBackground')
};

export default materialConfig;


// WEBPACK FOOTER //
// ./src/material-config.js